const getDefaultObserverOptions = (): IntersectionObserverInit => {
    return {
        root: null,
        rootMargin: '0px',
        threshold: 0.3,
    };
};

export const runOnceWhenVisible = (element: HTMLElement, callback: () => void) => {
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                callback();
                observer.unobserve(element);
            }
        });
    }, getDefaultObserverOptions());

    observer.observe(element);
};

export const runWhenVisible = (element: HTMLElement, callback: () => void, cleanup: () => void, customOptions: IntersectionObserverInit = getDefaultObserverOptions()) => {
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                callback();
            } else {
                cleanup();
            }
        });
    }, {...getDefaultObserverOptions(), ...customOptions});

    observer.observe(element);
}